import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {MemberRootState} from '../../interfaces'
import common from '../../slices/common'
import error from '../../slices/error'
import payNext from '../../slices/payNext'
import purchaser from '../../slices/purchaser'

const createRootReducer = (): Reducer<MemberRootState> =>
    combineReducers({
        common,
        error,
        payNext,
        purchaser,
        router: routerReducer,
    })

export default createRootReducer
